import React from "react";
import { Box, Icon, Tooltip } from "@chakra-ui/react";
import {
  SocialLinksProps,
  socialMediaIcons,
  socialMediaOrder,
} from "./SocialLinks.types";
import { capitalize } from "../../../utils";
import { ExternalLink } from "../ExternalLink";
import { IconButton } from "../IconButton";

export const SocialLinks: React.FC<SocialLinksProps> = ({ links, ...rest }) => {
  if (!links || !links.length) return <></>;
  return (
    <Box {...rest}>
      {socialMediaOrder.map((socialName, socialIndex) => {
        const socialMediaUrl =
          ((links || []).find((link) => link.name === socialName) || {}).url ||
          "";

        if (socialMediaUrl) {
          return (
            <Tooltip
              key={socialIndex}
              mt={5}
              label={capitalize(socialName)}
              borderRadius={4}
              bg={"bg.white"}
              color={"text.black"}
              textStyle={"bodySmall"}
              fontWeight={"normal"}
              hasArrow
            >
              <ExternalLink href={socialMediaUrl} target={"_blank"}>
                <IconButton p={2} mr={2} isCircle isGrey>
                  <Icon
                    as={
                      socialMediaIcons[
                        socialName as keyof typeof socialMediaIcons
                      ]
                    }
                    boxSize="24px"
                    color="text.black"
                  />
                </IconButton>
              </ExternalLink>
            </Tooltip>
          );
        }

        return null;
      })}
    </Box>
  );
};
